<template>
  <b-row>
    <b-card class="mt-2 col-12">
      <b-col cols="12">
        <SearchFilter
          ref="searchFilter"
          :mode="'ScreeningSend'"
          :label="'รายการส่งช่วงวันที่'"
          @handleSubmit="searchFilterSubmit"
        />
      </b-col>
    </b-card>

    <b-card class="mt-2 col-12">
      <b-col cols="12">
        <ReportIframe :iframeUrl="iframeUrl" />
      </b-col>
    </b-card>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";
import SearchFilter from "@/views/Complaint/components/ComplaintSummary/SearchFilter.vue";
import ReportIframe from "@/views/Complaint/components/ComplaintSummary/ReportIframe.vue";
import * as viewStore from "@/store/api/screening/screening.js";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    SearchFilter,
    ReportIframe,
    viewStore,
    BOverlay,
  },
  data() {
    return {
      iframeUrl: null,
    };
  },
  methods: {
    searchFilterSubmit(url) {
      this.iframeUrl = url;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
